const swiperService = {
  setAdList (list) {
    window.localStorage.setItem('adlist', JSON.stringify(list))
  },
  getAdList () {
    return JSON.parse(window.localStorage.getItem('adlist'))
  }
}

export default swiperService
